var map = {
	"./about.jpg": "bc25",
	"./binary.gif": "1bfd",
	"./binary.png": "1232",
	"./drawings/abstract.svg": "18fe",
	"./drawings/abstract2.svg": "6c82",
	"./drawings/curvystack.svg": "eeab",
	"./drawings/d20.svg": "8d6f",
	"./drawings/eyeguy.svg": "97bf",
	"./drawings/hand.svg": "e565",
	"./drawings/munch.svg": "b5ab",
	"./drawings/pretzel.svg": "c33a",
	"./drawings/pyramid.svg": "ff26",
	"./drawings/sitting.svg": "e46c",
	"./drawings/skinnyboi.svg": "d314",
	"./drawings/spiral.svg": "8f7e",
	"./drawings/stack.svg": "f8b0",
	"./drawings/stairs.svg": "670c",
	"./drawings/swoosh.svg": "d56c",
	"./drawings/tobby1.svg": "bb10",
	"./drawings/tobby2.svg": "aa17",
	"./drawings/traingles.svg": "e8bc",
	"./drawings/whoishe.svg": "5d75",
	"./drawings/x1.svg": "33ca",
	"./drawings/x2.svg": "6b94",
	"./drawings/zag.svg": "b789",
	"./drawings/zig.svg": "fd71",
	"./file select.aseprite": "266e",
	"./filedelete.gif": "5449",
	"./homepage/charity.png": "f1d2",
	"./homepage/computer.png": "3cd2",
	"./homepage/destijl.png": "28d2",
	"./homepage/sprites.svg": "3d57",
	"./homepage/tobbysit.jpg": "42ef",
	"./homepage/tobydesk.png": "7ca2",
	"./laugh-export.png": "38b0",
	"./laugh.ase": "6012",
	"./laugh.gif": "3123",
	"./laugh.png": "ce92",
	"./musicnotesicon.png": "9cf3",
	"./tobby/tobbySquare1.jpg": "fe24",
	"./tobby/tobbySquare2.jpg": "f596",
	"./tobby/tobbySquare3.jpg": "5dc3",
	"./tobby/tobbySquare4.jpg": "1a04",
	"./toby10.jpg": "9ad8",
	"./tobysquare.jpg": "44ca",
	"./underconstruction.gif": "bde3"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7584";